<script setup lang="ts">
// Long-form keyword copy + FAQ teaser that keep '/' rich in crawlable on-page
// SEO content. The hero is brand-led ("Мурчим твою судьбу"), so this section
// carries the search keywords ("расклад таро онлайн", etc.) + the FAQ.
// In paper: the long copy is a letter taped to the page, the FAQ items are sheets of stock.
import ScrollReveal from '@/components/ui/animation/ScrollReveal.vue';
import PaperLetter from '@app/presentation/components/paper/PaperLetter.vue';
import PaperFaqItem from './PaperFaqItem.vue';

const faqs = [
  {
    q: 'Это бесплатно?',
    a: 'Да. Четыре расклада — карта дня, «да или нет», «задай вопрос» и расклад на три карты — бесплатны. Остальные открываются по подписке.',
  },
  {
    q: 'Расклады правда персональные?',
    a: 'Каждая интерпретация учитывает твой вопрос и конкретные выпавшие карты. Это не заранее записанные тексты, а живой разбор именно твоей ситуации.',
  },
  {
    q: 'Таро — это серьёзно или развлечение?',
    a: 'Это ровно то, чем ты захочешь это сделать. Мы не обещаем магию — мы даём повод остановиться, посмотреть на ситуацию со стороны и услышать себя.',
  },
];
</script>

<template>
  <section id="seo" class="scroll-mt-20 py-16 md:py-24">
    <div class="site-container space-y-16">
      <!-- Long-form SEO copy (keyword-rich, crawlable) -->
      <ScrollReveal>
        <PaperLetter class="mx-auto max-w-4xl">
          <div class="md:px-7 md:pb-6 md:pt-4">
            <h2 class="type-heading mb-5 text-center">
              Расклад таро онлайн — это про ясность, а не про магию
            </h2>
            <p class="letter-text mx-auto max-w-3xl text-[15px] leading-[1.7] text-muted-foreground">
              Бывает так: ты застряла в ситуации, которая выматывает, отношения запутались,
              на работе непонятно куда двигаться, а внутри — ощущение, что живёшь не свою жизнь.
              Хочется ясности, но не знаешь, с чего начать. Расклад таро онлайн — это не магическое
              предсказание и не обещание чудес. Это способ остановиться, посмотреть на ситуацию
              со стороны и услышать то, что ты, возможно, уже знаешь, но боишься признать.
              Таро Мяу — это бесплатное гадание таро с тёплым личным разбором, без
              шаблонных ответов. Каждый расклад таро онлайн учитывает твой вопрос и конкретные карты,
              которые тебе выпали. 16 видов раскладов — от быстрого «да или нет» до глубокого
              анализа отношений, карьеры и финансов. Задай вопрос, вытяни карты и получи
              развёрнутую интерпретацию, написанную живым языком, а не сухим учебником.
              А если захочешь копнуть глубже — загляни в чат: там тебя ждёт мудрый кот-таролог,
              который поможет разобраться в раскладе и задаст правильные вопросы.
              Здесь можно изучать таро с нуля: 78 карт с описаниями, тренажёры для запоминания
              и практики интерпретации. Первые расклады — бесплатно и без всякой подготовки:
              просто открой, задай вопрос и посмотри, что скажут карты. Решение всегда остаётся за тобой, а карты лишь подсветят
              то, что стоит заметить.
            </p>
          </div>
        </PaperLetter>
      </ScrollReveal>

      <!-- FAQ teaser -->
      <div>
        <ScrollReveal class="mb-8 text-center">
          <h2 class="type-display">Частые вопросы</h2>
        </ScrollReveal>
        <div class="mx-auto max-w-2xl space-y-3.5">
          <ScrollReveal
            v-for="(f, i) in faqs"
            :key="i"
            :delay="(i + 1) * 80"
          >
            <PaperFaqItem
              :question="f.q"
              :answer="f.a"
              :tilt="[-0.3, 0.25, -0.2][i % 3]"
            />
          </ScrollReveal>
        </div>
      </div>
    </div>
  </section>
</template>
